'use client'

import { type PropsWithChildren, useEffect, useSyncExternalStore } from 'react'

const listeners = new Set<() => void>()
let showBorder = false

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

function setFrameBorder(value: boolean) {
  showBorder = value
  listeners.forEach(l => l())
}

export function FrameBorderProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    setFrameBorder(true)
    return () => setFrameBorder(false)
  }, [])
  return children
}

export function useFrameBorder() {
  return useSyncExternalStore(
    subscribe,
    () => showBorder,
    () => false
  )
}
